import type { DepartmentTreeNode } from '@/shared/types/models/department.model'
import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

type DepartmentState = {
  selectedDepartmentNode: DepartmentTreeNode | null
}

const initialState: DepartmentState = {
  selectedDepartmentNode: null,
}

const departmentSlice = createSlice({
  name: 'department',
  initialState,
  reducers: {
    selectDepartment(state, action: PayloadAction<DepartmentTreeNode>) {
      state.selectedDepartmentNode = action.payload
    },
    clearDepartment(state) {
      state.selectedDepartmentNode = null
    },
  },
})

export const { selectDepartment, clearDepartment } = departmentSlice.actions

export default departmentSlice.reducer
